import React, { useState } from "react";
import axios from "axios";
import "../../styles/PasswordChange.css";
import { FaLock } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

const PasswordChange = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'error' | 'success'

  const navigate = useNavigate();
  const location = useLocation();
  const { clientCode, token, Server_IP } = location.state || {};
  if (!clientCode || !token || !Server_IP) {
    return <div>잘못된 접근입니다. 다시 로그인해주세요.</div>;
  }

  function isValidPassword(password) {
    const minLength = 6;
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return password.length >= minLength && specialCharRegex.test(password);
  }

  const handleChangePassword = async () => {
    setMessage("");
    setMessageType("");

    if (isValidPassword(newPassword) === false) {
      setMessage(
        "비밀번호는 최소 6자 이상이어야 하며, 특수문자를 포함해야 합니다."
      );
      setMessageType("error");
      return;
    }
    
    if (!currentPassword || !newPassword || !confirmPassword) {
      setMessage("모든 필드를 입력하세요.");
      setMessageType("error");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("새 비밀번호가 일치하지 않습니다.");
      setMessageType("error");
      return;
    }

    try {
      const result = await axios.post(
        `${Server_IP}/api/changeClientBookPassword/`,
        { clientCode, currentPassword, newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (result.data === true) {
        setMessage("비밀번호가 성공적으로 변경되었습니다.");
        setMessageType("success");

        setTimeout(() => {
          navigate("/login");
        }, 1500); // 1.5초 후 로그인 페이지로 이동
      } else {
        setMessage("비밀번호 변경에 실패했습니다. 현재 비밀번호를 확인하세요.");
        setMessageType("error");
      }
    } catch (error) {
      console.error("비밀번호 변경 오류 - status:", error.response?.status, "data:", error.response?.data, error);
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        setMessage("현재 비밀번호를 잘못 입력하였습니다.");
      } else {
        setMessage("서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
      }
      setMessageType("error");
    }
  };

  const handleBack = () => {
    navigate("/login");
  };

  return (
    <div className="password-change-card">
      <div className="header">
        <FaLock size={20} />
        <span>비밀번호 변경</span>
      </div>

      <div className="form-group">
        <label>현재 비밀번호</label>
        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>새 비밀번호</label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>비밀번호 확인</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </div>

      <div className="button-group">
        <button className="btn-save" onClick={handleChangePassword}>
          저장
        </button>
        <button className="btn-back" onClick={handleBack}>
          로그인
        </button>
      </div>

      {message && (
        <div
          className="message"
          style={{ color: messageType === "success" ? "#2e7d32" : "#d32f2f" }}
        >
          {message}
        </div>
      )}
    </div>
  );
};

export default PasswordChange;
